// removed by extract-text-webpack-plugin
module.exports = {"select":"magazines_30Yxc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/FontSize/styles.scss
// module id = 1076
// module chunks = 1